<div class="container-flex">
  <div class="tabla-container">
    <app-tabla
      [totalCount]="totalCount"
      [datos]="logEvento"
      [columnas]="columnas"
      [name]="name"
      [pageSizeOptions]="helper.pageSizeOptions"
      [search]="search"
      [(query)]="query"
      (queryChange)="listar()"
      [paginatorArriba]="false"
      [filtros]="filtros"
      [emptyState]="{ title: 'Todavía no hay eventos LoRa' }"
    ></app-tabla>
  </div>

  @if (logEventoSeleccionado) {
    <div class="detalles-container">
      <app-detalles-request-http
        [title]="'Detalles Evento LoRa - ID: ' + logEventoSeleccionado._id"
        [data]="logEventoSeleccionado"
        (close)="cerrarDetalles()"
      ></app-detalles-request-http>
    </div>
  }
</div>
